export const GET_PATIENT_ALERT_CONFIGURATION =
  'patientAlertConfiguration/getPatientAlertConfiguration'
export const ADD_PATIENT_ALERT_CONFIGURATION =
  'patientAlertConfiguration/addPatientAlertConfiguration'
export const SERVER_ERROR_ALERT_CONFIGURATION =
  'patientAlertConfiguration/errorPatientAlertConfiguration'
